import { TaskItemView } from "../api/generated/models/TaskItemView";
import { TaskPatchRequest } from "../api/generated/models/TaskPatchRequest";
import type { ListingInspectorContextView } from "../api/generated/models/ListingInspectorContextView";

export const TASK_BOARD_STATUSES = [
  TaskItemView.status.OPEN,
  TaskItemView.status.IN_PROGRESS,
  TaskItemView.status.DONE,
] as const;

export type TaskBoardStatus = (typeof TASK_BOARD_STATUSES)[number];

export const TASK_MODAL_STATUSES = [
  TaskItemView.status.OPEN,
  TaskItemView.status.IN_PROGRESS,
  TaskItemView.status.DONE,
  //  TaskItemView.status.DISMISSED,
] as const;

export function isTaskBoardStatus(status?: string): status is TaskBoardStatus {
  return TASK_BOARD_STATUSES.includes(status as TaskBoardStatus);
}

export function getTaskImageUrl(
  images?: ListingInspectorContextView["images"],
): string | null {
  if (!images || images.length === 0) {
    return null;
  }

  const first = images[0];
  if (typeof first === "string") {
    return first;
  }

  return first.url ?? first.URL ?? null;
}

export function getTaskShopUrl(
  listing?: ListingInspectorContextView | null,
): string | null {
  if (!listing) {
    return null;
  }

  return listing.productUrl ?? listing.url ?? null;
}

export function getTaskStatusClassName(status?: string): string {
  switch (status) {
    case TaskItemView.status.IN_PROGRESS:
      return "tasks-card-status--in-progress";
    case TaskItemView.status.DONE:
      return "tasks-card-status--done";
    case TaskItemView.status.DISMISSED:
      return "tasks-card-status--dismissed";
    case TaskItemView.status.OPEN:
    default:
      return "tasks-card-status--open";
  }
}

export function toPatchStatus(
  status: string,
): TaskPatchRequest.status {
  switch (status) {
    case TaskItemView.status.IN_PROGRESS:
      return TaskPatchRequest.status.IN_PROGRESS;
    case TaskItemView.status.DONE:
      return TaskPatchRequest.status.DONE;
    case TaskItemView.status.DISMISSED:
      return TaskPatchRequest.status.DISMISSED;
    case TaskItemView.status.OPEN:
    default:
      return TaskPatchRequest.status.OPEN;
  }
}

export function getTaskIssueTranslationKey(issue: string): string {
  return `tasks_issue_${issue}`;
}

export function getTaskIssueLabel(
  issue: string,
  translate: (key: string) => string,
): string {
  const key = getTaskIssueTranslationKey(issue);
  const label = translate(key);
  return label !== key ? label : issue.replace(/_/g, " ");
}
